export const normalizePath = (path: string | number): string => {
	return `${path}`.replace(/^\/+|\/+$/g, '');
};

export const joinPath = (...paths: string[]): string => {
	return paths.map(normalizePath).filter(Boolean).join('/');
};
